export enum FileUploadTypes {
  featuredImage = 'featuredImage',
  tagFeaturedImage = 'tagFeaturedImage',
}
